export default {"src":"/pro/_next/static/media/arb.25bdc134.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};